// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlight-row {
  background-color: #F8B4B4 !important;
}
`, "",{"version":3,"sources":["webpack://./src/page-components/OrderProgressTracking/orderProgress.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC","sourcesContent":[".highlight-row {\n  background-color: #F8B4B4 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
